import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { WithdrawalsApiAdapter } from '../adapters';
import { WITHDRAWALS_QUERY_KEY } from './useWithdrawals';

export const PENDING_REVIEW_WITHDRAWALS_QUERY_KEY = 'pendingReviewWithdrawals';

/** Carga todas las retiradas en estado PENDING_REVIEW para el modal de generación de ficheros */
export const usePendingReviewWithdrawals = (enabled = false) => {
  const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
  const apiAdapter = useMemo(() => new WithdrawalsApiAdapter(httpClient), [httpClient]);

  return useQuery({
    queryKey: [WITHDRAWALS_QUERY_KEY, PENDING_REVIEW_WITHDRAWALS_QUERY_KEY],
    queryFn: async () => {
      const response = await apiAdapter.getWithdrawals(null, {
        page: 1,
        perPage: 500,
        advanced_filters: {
          filters: [{ column: 'status', operator: 'in', value: ['PENDING_REVIEW'] }],
          logic: 'AND',
        },
      });
      return response.data;
    },
    enabled,
    staleTime: 30 * 1000,
  });
};
